import { AlertTypes } from '../util/Constant.js';
import i18n from '../localization/i18n';

export const _BUSY = 'busy';
export const _IDLE = 'idle';
export const _API_CALLED = 'setApiCalled';
export const _DOWNLINE_SEARCH = 'setDownlineSearchTextCalled';
export const _DOWNLINE_QUERY = 'setDownlineQueryCalled';
export const _GAME_SEARCH = 'setGameSearchTextCalled';
export const _GAME_QUERY = 'setGameQueryCalled';
export const _SET_Y = "setY";
export const _SET_PAGESIZE = "setPageSize";
export const _SET_ACTIVE_TAB = "setActiveTab";
export const _IS_KEEPED_LOGIN = "userKeepLogin";

export const _ALERT_TYPES = {
    SET_ALERT: 'SetAlert',
    NONE: 'AlertNone',
}

export const setY = (y) => {
    return (dispatch) => {
        dispatch({
            type: _SET_Y,
            y,
        });
    };
};

export const setPageSize = (pagesize) => {
    return (dispatch) => {
        dispatch({
            type: _SET_PAGESIZE,
            data: pagesize,
        });
    };
};

export const setActiveTab = (activeTab) => {
    return (dispatch) => {
        dispatch({
            type: _SET_ACTIVE_TAB,
            data: activeTab,
        });
    };
};

export const userKeepLogin = (isKeepedLogin) => {
    return (dispatch) => {
        dispatch({
            type: _IS_KEEPED_LOGIN,
            data: isKeepedLogin,
        });
    };
};

export const setDownlineSearchText = (e) => {
    return async dispatch => {
        dispatch({
            type: _DOWNLINE_SEARCH,
            data: e
        });
    }
}

export const setDownlineQuery = (e) => {
    return async dispatch => {
        dispatch({
            type: _DOWNLINE_QUERY,
            data: e
        });
    }
}

export const setGameSearchText = (e) => {
    return async dispatch => {
        dispatch({
            type: _GAME_SEARCH,
            data: e
        });
    }
}

export const setGameQuery = (e) => {
    return async dispatch => {
        dispatch({
            type: _GAME_QUERY,
            data: e
        });
    }
}

/// <summary>
/// Author : 
/// </summary>
export const setBusy = (iconEnabled, message) => {
    return async dispatch => {
        dispatch({
            type: _BUSY,
            message: message,
            iconEnabled: iconEnabled
        });
    }
}

/// <summary>
/// Author : 
/// this function is to only update user status to logout
/// </summary>
export const setIdle = () => {
    return async dispatch => {
        dispatch({
            type: _IDLE
        });
    }
}

/// <summary>
/// Author : 
/// </summary>
export const setPerformApiCall = (status, url) => {
    return async dispatch => {
        dispatch({
            type: _API_CALLED,
            data: { success: status, url: url }
        });
    }
}

/// <summary>
/// Author: -
/// </summary>
export const showResponseMessage = (status, message, translateRequired = true) => {
    return dispatch => {
        var messageToShow = message;
        if (translateRequired) {
            messageToShow = i18n.t(message);
        }
        dispatch(showMessage({ type: (status ? AlertTypes._SUCCESS : AlertTypes._ERROR), content: messageToShow }));
    }
}

/// <summary>
/// Author: -
/// </summary>
export const showMessage = (alertProps) => {
    return dispatch => {
        const customConfirm = alertProps.onConfirm;
        alertProps.onConfirm = async (...args) => {
            disposeMessage()(await dispatch);
            if (customConfirm) {
                customConfirm(...args);
            }
        }

        const customCancel = alertProps.onCancel;
        alertProps.onCancel = async (...args) => {
            disposeMessage()(await dispatch);
            if (customCancel) {
                customCancel(...args);
            }
        }

        alertProps.cancelBtnBsStyle = 'danger';
        alertProps.title = alertProps.title ?? "";
        alertProps.allowEscape = false;
        alertProps.reverseButtons = true;

        dispatch({ type: _ALERT_TYPES.SET_ALERT, alert: alertProps });
    }
}

/// <summary>
/// Author: -
/// </summary>
export const disposeMessage = () => {
    return dispatch => {
        dispatch({ type: _ALERT_TYPES.NONE });
    }
}